export const showitemMap = {
  "Overall": {
    placeholder_key1: true,
    placeholder_key2: true,
    placeholder_key4: true,
  },
  "storageAreas": {
    placeholder_key1: true,
    placeholder_key2: true,
    placeholder_key4: true,
  },
  "Simplelnspection": {
    placeholder_key1: true,
    placeholder_key2: true,
    placeholder_key4: true,
  },
  "TransfersNumber": {
    placeholder_key2: true,
    placeholder_key4: true,
    placeholder_key5: true,
    placeholder_key6: true,
  },
  Pinking: {
    placeholder_key1: true,
    placeholder_key2: true,
    placeholder_key4: true,
  },
  shelvesNumber: {
    placeholder_key1: true,
    placeholder_key2: true,
    placeholder_key3: true,
    placeholder_key4: true,
  },
  QI: {
    placeholder_key1: true,
    placeholder_key4: true,
  },
};
